import { render } from "./ExportarRecolhas.vue?vue&type=template&id=d9cb3f8a"
import script from "./ExportarRecolhas.vue?vue&type=script&lang=js"
export * from "./ExportarRecolhas.vue?vue&type=script&lang=js"
script.render = render

export default script